export enum CmsModelType {
  SINGLETON = 'SINGLETON',
  COLLECTION = 'COLLECTION',
}

export enum CmsFieldType {
  TEXT = 'TEXT',
  EMAIL = 'EMAIL',
  TEXT_AREA = 'TEXT_AREA',
  RICH_TEXT = 'RICH_TEXT',
  FILE = 'FILE',
}

export interface CmsModelField {
  key: string
  required?: boolean
  useAsTitle?: boolean
  type: CmsFieldType
  label: string
  uuid: string
}

export interface CmsModel {
  label: string
  labelPlural?: string
  key: string
  uuid: string
  type: CmsModelType
  fields: CmsModelField[]
}
